// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1RZOs","title":"BackImages_title__2AzF0","images":"BackImages_images__1u6Sv"};